import React from 'react';
import { RoleList as RolesPage } from 'src/containers/adminDashboard/RoleList/roleList.component';
import { StudyList } from 'src/containers/adminDashboard/StudyList/StudyList.component';
import { Users as UsersPage } from 'src/containers/adminDashboard/UserList/UserList.component';

export const AdminStudies = () => <StudyList />;
export const Users = () => <UsersPage />;
export const Roles = () => <RolesPage />;
